import { profilesApi } from '@/api';
import styles from './set-email.module.scss';
import { useNavigate } from 'react-router-dom';
import { EmailForm } from '@/components/email-form';
import { LockIcon, SuccessNotificationIcon } from '@/assets/icons';
import { Typography } from '@/ui-kit';
import { useTranslation } from 'react-i18next';
import { useQueryClient } from '@tanstack/react-query';
import { verifyOTPForProfile } from '@/utils/verify-otp-for-profile';
import { useToast } from '@/store/useToast';

export const SetEmail = () => {
    const navigate = useNavigate()

    const { t } = useTranslation()

    const queryClient = useQueryClient()

    const showToast = useToast(state => state.show)

    const onLogin = () => {
        navigate(-1)
        queryClient.invalidateQueries({ queryKey: ['profile'] })
        showToast({
            icon: <SuccessNotificationIcon />,
            msg: t('profile.email_linked')
        })
    }

    return (
        <div className={styles.settings}>
            <div className={styles.emailFormWrapper}>
                <EmailForm
                    emailFormClass={styles.emailForm}
                    useGradient={false}
                    emailHeader={
                        <div className={styles.note}>
                            <LockIcon
                                className={styles.noteIcon}
                                width={24}
                                height={24} />
                            <div className={styles.noteTexts}>
                                <Typography variant="p" fontWeight="semibold">
                                    {t('profile.link_email_title')}
                                </Typography>
                                <Typography variant="p" className={styles.subtitleForm}>
                                    {t('profile.link_email_subtitle')}
                                </Typography>
                            </div>
                        </div>
                    }
                    disabledNextBtnStyles={styles.disabledNextBtn}
                    requestOTP={
                        (email: string) =>
                            profilesApi.requestOTPForProfile({
                                profile: { unconfirmed_email: email }
                            })
                    }
                    verifyOTP={verifyOTPForProfile}
                    onLogin={onLogin} />
            </div>
        </div>
    );
};
